
import constants from 'Constants.js';
import connectionController from 'ConnectionController';
import listService from "ListService";

//================================================================================================================
// Static helper class extracted from BaseGraphicsPageView to isolate connection arrow render updating logic.
// -Lou Mauget 2017-09-14
//================================================================================================================
class ConnectionTracker {
    constructor() { throw "ConnectionTracker is static"; }

    // Helpers determine info for reacting to line slant during connected end movements

    static _isPlusHeight( line ) { return line.get('y1') < line.get('y2'); }

    static  _isPlusWidth( line ) { return line.get('x1') < line.get('x2'); }

    // Moves an end of the line appropriate to slant and whether end A or B
    // Caller must determine those conditions, the call pair of appropriate move methods.

    static _movePlusHeight(line, d) {
        line.set({
            'top': line.get('top') + d.dy,
            'height': line.get('height') - d.dy
        });
    }

    static _movePlusWidth(line, d) {
        line.set({
            'width': line.get('width') + d.dx
        });
    }

    static _moveNegHeight(line, d) {
        line.set({
            'height': line.get('height') + d.dy
        });
    }

    static _moveNegWidth(line, d) {
        line.set({
            'left': line.get('left') + d.dx,
            'width': line.get('width') - d.dx
        });
    }

    //================================================================================================================
    // Core logic to track sticky connection rendering.
    // Callable by object:moving event handler, or call it directly, passing a reduced mock object:moving fabric event
    //================================================================================================================
    static trackConnections(evt ){

        const obj = evt.target;

        const fcanvas = listService.fcanvas;
        const activeGroup = fcanvas.getActiveGroup() ;

        let moveWithKeyboard = evt.e.keyboardMove ? evt.e.keyboardMove : false;

        // TODO JQuery normalizes pageX/Y across ALL browsers, so why do we have the x,y fallback?
        const x = evt.e.pageX ||  evt.e.x;
        const y = evt.e.pageY ||  evt.e.y;

        // We cached stage or behavior's or group's last known position from our own last movement at end of this method
        const objPrevPos = (w => w.prevPos ? w.prevPos : {'left': obj.left, 'top': obj.top } )(obj);

        // TODO get from properties
        const gridSize = constants.GRIDSIZE_FOR_BEHAVIOR_AND_WORKFLOW;

        // Understand that the target stage / behavior / group has ALREADY MOVED by Fabric.js. It is our job here
        // to (1) modify that movement if in snap mode, and, (2) move all paths connected to the target accordingly.

        // ptSnapto is the FUTURE target move-to position. It is a function of event position and snap-to-grid mode.
        // The value is a point position that either snaps or slides, according to snapToGrid mode.
        // We'll use this value to develop the path movement delta, and near the end of this method, to conditinoally
        // modify the target location if in snap-to-grid mode.
        const ptSnapTo = ( (w, gs) => {
            const d = {left: w.left, top: w.top};
            if (listService.snapToGrid && !moveWithKeyboard){
                d.left = Math.round(w.left / gs) * gs;
                d.top = Math.round(w.top / gs) * gs;
            }
            return d;
        })(obj, gridSize);

        // Only adjust the connection lines if the widget group is not currently in a drawing state
        const moving = connectionController.state === connectionController.DEFCON_0 &&
                                   !obj.lockMovementX && !obj.lockMovementY;

        // Here is the path-snapping magic:
        // delta is a function of object's previous position vs its future position via either snap or slide;
        const delta = (() => {
            const d = {  };
            d.dx = ptSnapTo.left - objPrevPos.left;
            d.dy = ptSnapTo.top - objPrevPos.top;
            return d;
        })();


        // If the target widget, or widgets of a target group, have connections, then for each connection point
        // in the connection list: move line ends from it's connection list a delta from the last known position.
        // Either axis of the delta point could be 0 in snap mode.

        if ( obj.connection &&  moving) {

            // Move owned end of all connections anchored in this object's "connection" list
            _.forEach( obj.connection, conn => ConnectionTracker.moveEndOfConnection( conn, delta ) );

        } else if (activeGroup && moving) {

            function isConnectable( w ){
                return w.model && w.model.has('factoryKey')
                    && (w.model.get('factoryKey') === 'workflow_stage' || w.model.get('factoryKey').startsWith('command_') );
            }

            function isConnectionObject( w ){
                return w.model && w.model.has('factoryKey')
                    && w.model.get('factoryKey') === 'connection_arrow' ;
            }

            const
                grRect = activeGroup.getBoundingRect(),
                grX = grRect.left + grRect.width / 2,
                grY = grRect.top + grRect.height / 2;

            // Ensure no connections are selected. We intend to move connections by tracking each anchor widget movement.
            activeGroup.forEachObject( c => {
                if (isConnectionObject(c)){

                    // Yes, remove any connection path from the Fabric group selection.
                    // A "selected" path is merely drawn differently in Yoda (see WorkFlowPageVIew and BehaviorsPageView)
                    activeGroup.remove(c);

                    // Connection paths depart group's coordinate system to join that of parent canvas ...
                    // ... offset it to the correct visual place  in that system
                    c.left += grX;
                    c.top += grY;
                }
            });

            // Move this end of connection path anchored to each selected connectable (stage or behavior):
            activeGroup.forEachObject( w => {
                if (isConnectable(w) && w.connection){
                    w.connection.forEach( c => ConnectionTracker.moveEndOfConnection(c, delta));
                }
            });

        }

        // Conditionally snap the target object to the grid. (It may appear visually stationary in snap mode)
        if (listService.snapToGrid && !moveWithKeyboard){
            // console.log(`Before snap: (${obj.left},${obj.top})`);
            obj.set({
                'left': ptSnapTo.left,
                'top': ptSnapTo.top
            });
        }

        // We've (maybe) moved the object. Cache its location -- Fabric could move it before next call to this method
        // Used to calculate delta for any kind of snapToGrid or smooth movement
        obj.prevPos = {'left': obj.left, 'top': obj.top};

        //Check if the object is moved outside the visible area of the canvas to activate the scrolling
        const scrollBarLeft = $(constants.FORM_ID).scrollLeft();
        const scrollBarTop  = $(constants.FORM_ID).scrollTop();

        const canvasWidth = $(constants.FORM_ID).width();
        const canvasHeight = $(constants.FORM_ID).height();

        const objWidth = obj.width;
        const objLeft = obj.left + obj.width;
        const objTop = obj.top;
               
        const scrollBarOffset = 10;
       
        if(obj.left < scrollBarLeft){ //Left edge

            if(scrollBarLeft > 0){
                $(constants.FORM_ID).scrollLeft(obj.left);
                
                // window.setTimeout(() => {
                    
                //     this.selectFabricObject(fcanvas, selectedFabric, group);
                // }, 0);
            }           
        }

        if(objLeft > canvasWidth){ //Right edge
           
            let newScrollPosition = objLeft - canvasWidth + scrollBarOffset;

            if(scrollBarLeft < newScrollPosition){
                $(constants.FORM_ID).scrollLeft(newScrollPosition);
            }           
        }

        // PF-8386 UP/DOWN SCROLL
        if(obj.top < scrollBarTop){ //Top edge

            if(scrollBarTop > 0){
                $(constants.FORM_ID).scrollTop(obj.top);
                
                // window.setTimeout(() => {
                    
                //     this.selectFabricObject(fcanvas, selectedFabric, group);
                // }, 0);
            }           
        }

        if(objTop > canvasHeight){ //Bottom edge

            let newScrollPosition = objTop - canvasHeight + scrollBarOffset;

            if(scrollBarTop < newScrollPosition){
                $(constants.FORM_ID).scrollTop(newScrollPosition);
            }      
        }
    }


    //================================================================================================================
    // Move owned end of connection by deltaPoint, an (x,y) point.
    // A_END is outbound base of connection arrow.
    // B_END is inbound arrowhead of connection arrow.
    //================================================================================================================
    static moveEndOfConnection( conn, deltaPoint ) {
        if (conn.end === constants.A_END) {
            // Begin-drawing line - end

            ConnectionTracker._isPlusHeight(conn.line) ?
                ConnectionTracker._movePlusHeight(conn.line, deltaPoint) :
                ConnectionTracker._moveNegHeight(conn.line, deltaPoint);

            ConnectionTracker._isPlusWidth(conn.line) ?
                ConnectionTracker._moveNegWidth(conn.line, deltaPoint) :
                ConnectionTracker._movePlusWidth(conn.line, deltaPoint);


        } else if (conn.end === constants.B_END) {
            // Ended-drawing line end: the arrow end.

            ConnectionTracker._isPlusHeight(conn.line) ?
                ConnectionTracker._moveNegHeight(conn.line, deltaPoint) :
                ConnectionTracker._movePlusHeight(conn.line, deltaPoint);

            ConnectionTracker._isPlusWidth(conn.line) ?
                ConnectionTracker._movePlusWidth(conn.line, deltaPoint) :
                ConnectionTracker._moveNegWidth(conn.line, deltaPoint);

        }
        conn.line.setCoords();
        // console.log('line', conn.line);
    }

    //================================================================================================================
    // For the two circular shapes (branches), move owned end of connection by deltaPoint, a (dx,dy) point.
    // Determine the active end of the connection line, and then increment that end's point by the signed deltaPoint.
    // A_END is outbound base of connection arrow.
    // B_END is inbound arrowhead of connection arrow.
    //================================================================================================================
    static moveEndOfConnectionOfCircle(conn, d ){
        const line = conn.line;

        //console.log(`line (x1: ${line.x1}, y1: ${line.y1}), (x2: x${line.x2}, y2: ${line.y2})`);

        if (conn.end === constants.A_END) {
            line.x1 -= d.dx;
            line.y1 -= d.dy;
        } if (conn.end === constants.B_END) {
            line.x2 -= d.dx;
            line.y2 -= d.dy;

        }
        line.setCoords();
    }

}

export default ConnectionTracker;
